var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-portlet-base',{attrs:{"title":_vm.title,"loading":_vm.localLoading,"tooltip":_vm.tooltip,"showError":_vm.error,"footer":_vm.footer,"simple":""}},[_c('iframe',{style:(_vm.iframeStyles),attrs:{"id":_vm.iframeId,"src":_vm.src},on:{"load":_vm.onIframeLoad,"error":function($event){_vm.error = true}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }